import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { ProductCreateWfoodcostPricePage } from "../../product-create/product-create-without-foodcost/product-create-wfoodcost-price/product-create-wfoodcost-price";
import { Globals } from "../../../../globals";
import { ProductCreateFoodcostPricePage } from '../../product-create/product-create-foodcost/product-create-foodcost-price/product-create-foodcost-price';

/**
 * Generated class for the ProductViewTopPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-product-view-top',
  templateUrl: 'product-view-top.html',
})
export class ProductViewTopPage {
  @Input() product: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals) {
  }

  edit() {
    if (this.product.sub_recipe == false) {
      this.navCtrl.push(ProductCreateWfoodcostPricePage, {
        update_state: true,
        product_uid: this.product.UID,
        product_name: this.product.name,
        pvp: this.product.pvp,
        pvp2: this.product.pvp2,
        pvp3: this.product.pvp3,
        pvp_supplement: this.product.pvp_supplement,
        pvp_combo_extra: this.product.pvp_combo_extra,
        pvp_takeaway: this.product.pvp_takeaway,
        ean: this.product.ean,
        product: this.product,
      })
    } else {
      this.navCtrl.push(ProductCreateFoodcostPricePage, {
        update_state: true,
        product_uid: this.product.UID,
        products: this.product,
        product_name: this.product.name,
        pvp: this.product.pvp,
        pvp2: this.product.pvp2,
        pvp3: this.product.pvp3,
        pvp_supplement: this.product.pvp_supplement,
        pvp_combo_extra: this.product.pvp_combo_extra,
        pvp_takeaway: this.product.pvp_takeaway,
        ean: this.product.ean,
        product: this.product,
      })
    }
  }
  profitFoodCost(price, _foodcost, _parts, _type) {
    var foodcost = (_foodcost / _parts) * _type
    //Quitamos el tax del precio
    price = this.globals.createSubTotal(price,this.globals.RESTAURANT_TAX);
    return 100 - this.globals.regla3(price, foodcost);
  }


}



// WEBPACK FOOTER //
// ./src/pages/products/product-view/product-view-top/product-view-top.ts